import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "MobileMenuIcon",
  "use": "MobileMenuIcon-usage",
  "viewBox": "0 0 42 42",
  "content": "<symbol viewBox=\"0 0 42 42\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"MobileMenuIcon\">\n  <circle cx=\"20.5\" cy=\"13.5\" r=\"2.5\" fill=\"currentcolor\" />\n  <circle cx=\"20.5\" cy=\"21.5\" r=\"2.5\" fill=\"currentcolor\" />\n  <circle cx=\"20.5\" cy=\"29.5\" r=\"2.5\" fill=\"currentcolor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol